import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="w-full bg-[#faf6ef] py-20 px-6 text-[#1e2a4a]" data-id="element-174">
      <div className="max-w-[680px] mx-auto" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-176">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-8 text-[#1e2a4a]" data-id="element-177">
            Your child isn't "bad at sleep."
          </h2>

          <div className="space-y-6 text-lg md:text-xl leading-[1.8] text-[#1e2a4a]/80" data-id="element-178">
            <p data-id="element-179">Kids 4–6 are:</p>
            <ul className="list-disc pl-6 space-y-2 marker:text-[#c9a96e]" data-id="element-180">
              <li data-id="element-181">smart enough to negotiate,</li>
              <li data-id="element-182">emotional enough to escalate,</li>
              <li data-id="element-183">persistent enough to keep trying until something changes.</li>
            </ul>

            <p data-id="element-184">And at 8:45pm… something often changes.</p>
            <p data-id="element-185">Not because you're inconsistent. Because you're human.</p>
          </div>

          <div className="my-12 bg-[#f0eadd] p-8 rounded-xl border border-[#1e2a4a]/10 shadow-sm" data-id="element-186">
            <p className="text-xl font-serif font-bold mb-6 text-[#1e2a4a]" data-id="element-187">
              That's how bedtime becomes a slot machine:
            </p>
            <ul className="space-y-4" data-id="element-188">
              {['sometimes you do one more story', 'sometimes you answer one more question', 'sometimes you lie down "just for a minute"', 'sometimes you bargain', 'sometimes you snap (and feel awful)'].map((item, index) => <li key={index} className="flex items-start text-lg" data-id="element-189">
                  <span className="mr-3 text-[#c9a96e] text-xl" data-id="element-190">✦</span>
                  <span data-id="element-191">{item}</span>
                </li>)}
            </ul>
          </div>

          <p className="text-xl md:text-2xl font-serif italic text-[#1e2a4a] border-l-4 border-[#c9a96e] pl-6 py-2" data-id="element-192">
            To a kid, "sometimes" is a strategy. They're not trying to ruin your
            night. They're learning: If I keep going, I might get a different
            outcome.
          </p>
        </motion.div>
      </div>
    </section>;
}